import {Color} from '@/game/extend/color';

export const Colors = {
    starYellow: Color.fromHex('#FFE6B3'),
    starBlue: Color.fromHex('#B3CCFF'),
} as const;
